import styleParam from '../BookOnline/stylesParams';

export default styleParam;
